const en = {
  message: {
    'home': 'Home',
    'product': 'Products',
    'newcenter': 'News Center',
    'resource': 'Resource Center',
    'aboutus': 'About Us',
    'agent': 'Agent',
    'cooperation': 'Cooperation',
    'with': 'Discuss with CEO',
    'contact': 'Contact me',
    'email': 'Email',
    'code': 'wechat scan pay attention to the public number',
    'time': ' Monday to Sunday 09:00-18:00 ',
    'company': ' Shenzhen Laolesi Technology Co., LTD. ',
    'record':'All Rights Reserved Guangdong ICP for 2025429618',
    'list': ' Quxin APP Already listed: ',
    'application': ' Application treasure ',
    'store': ' Select the app store by phone type and region ',
    'install': ' Download and install ',
    'download': ' Download ',
    'name': 'Name',
    'picture': 'Picture',
    'times': 'Time',
    'productlist': ' Product list ',
    'codes': 'Code',
    'material': 'Material',
    'color': 'Color',
    'brand': 'Brand',
    'function': 'Function',
    'consult': 'Consult immediately',
    'prev': 'Prev',
    'next': 'Next',
    'click': 'download',
    'pack': 'download',
    'volume': 'volume',
  }
}
export default en
